//COMPRESS STRING
import { compressToUTF16 as compress, decompressFromUTF16 as decompress }  from 'lz-string';

// recaptcha
import { VueReCaptcha } from 'vue-recaptcha-v3'
const env = require('../config')
Vue.use(VueReCaptcha, {
  siteKey: env.build.googleSiteKey,
})

// Vue instance
import Vue from 'vue';
Vue.config.productionTip = false;

// Main app
import Dtt from '@/Dtt';

// Se importa el Enrutador y handler login
import VueRouter from 'vue-router';
Vue.use(VueRouter);

import { routes } from '@/routes/router';
const router = new VueRouter({
  mode: 'history',
  routes: routes,
  linkActiveClass: 'is-active',
});

//Se importa plugin de filtros _ lodash
import { _ , range } from 'lodash';
window._ = require('lodash');

//Se importa nuestro bus de eventos
import EventBus from '@/plugins/event-bus';
Vue.use(EventBus);

import checkRelationFilter from '@/utils/filters/checkRelation.js';
Vue.use(checkRelationFilter);

import cutLongText from '@/utils/filters/cutLongText.js';
Vue.use(cutLongText);

import currency from '@/utils/filters/currency.js';
Vue.use(currency);

import checkFieldDataType from '@/utils/filters/checkFieldDataType.js';
Vue.use(checkFieldDataType);

import formatDate from '@/utils/filters/formatDate.js';
Vue.use(formatDate);

import { dateFilter } from "vue-date-fns";
Vue.filter("dttDate", dateFilter);


// only import the icons you use to reduce bundle size
import 'vue-awesome/icons/flag';

// or import all icons if you don't care about bundle size
import 'vue-awesome/icons';

/* Register component with one of 2 methods */

import Icon from 'vue-awesome/components/Icon';

import VModal from 'vue-js-modal';
Vue.use(VModal, {dialog: true});

// Se importa la libreria de notificaciones
import Notifications from 'vue-notification';
// Se instala el plugin importado
Vue.use(Notifications);
//BUEFY
import { library } from '@fortawesome/fontawesome-svg-core';
// internal icons
import { faCheck, faCheckCircle, faInfoCircle, faExclamationTriangle, faExclamationCircle,
         faArrowUp, faAngleRight, faAngleLeft, faAngleDown,
         faEye, faEyeSlash, faCaretDown, faCaretUp, faUpload, faPlus, faMinus} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faCheck, faCheckCircle, faInfoCircle, faExclamationTriangle, faExclamationCircle,
            faArrowUp, faAngleRight, faAngleLeft, faAngleDown,
            faEye, faEyeSlash, faCaretDown, faCaretUp, faUpload, faPlus, faMinus);
Vue.component('vue-fontawesome', FontAwesomeIcon);

//vue-validate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
  events: ''
});
//BUEFY
import Buefy from 'buefy';

Vue.use(Buefy, {});

import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDyX5M3wf_HUdCyleDZlzB-BXXV7cT1zDQ",
    libraries: "places", // necessary for places input
    autobindAllEvents: true,
  },
});

//i18n
import VueI18n from 'vue-i18n';
import en from './lang/en_US'
import es from './lang/es_ES'

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en',
  messages: {
    en: {
      lang: en
    },
    es: {
      lang: es
    }
  }
});

//VUEX IMPORT
import store from './store/index';

//ON CLICK OUTSIDE DIRECTIVE
import { directive as onClickOutside } from 'vue-on-click-outside'
Vue.directive('click-outside', onClickOutside)

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

// sentry integration
import { environmentService } from "@/utils/services";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

if (environmentService.production){
  Sentry.init({
    Vue,
    dsn: environmentService.sentryDsn,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: [environmentService.sentrySiteUrl, /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}

/* eslint-disable no-new, render de la app */
new Vue({
  el: '#Dtt',
  store,
  render: h => h(Dtt),
  i18n,
  router: router

});



// WEBPACK FOOTER //
// ./src/main.js